import moment from 'moment';
import { number } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
const INTERVAL_THRESHOLD = 'interval-threshold';
function IntervalThresholdValidator(value, { intervalThreshold = Number.MAX_SAFE_INTEGER } = {}) {
    let valid = true;
    let valueInterval = 0;
    const CURRENT_DAY = 1;
    if (Array.isArray(value)) {
        const diff = moment.utc(value[1]).diff(moment.utc(value[0]), 'days');
        valueInterval = diff + CURRENT_DAY;
        valid = valueInterval <= intervalThreshold;
    }
    return [{
            message: MessageService.translate('tws.validator.max-interval-exceeded', {
                exceeding: valueInterval - intervalThreshold,
                limit: intervalThreshold,
            }),
            name: INTERVAL_THRESHOLD,
            valid,
        }];
}
IntervalThresholdValidator.optionTypes = {
    intervalThreshold: number,
};
export { INTERVAL_THRESHOLD, IntervalThresholdValidator, };
export default IntervalThresholdValidator;
//# sourceMappingURL=interval-threshold.js.map